module.exports = __webpack_public_path__ + "img/فولدر.97685b94.png";